
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.78 2.388c-.796 0-1.56.316-2.123.88l-9.19 9.19a5.003 5.003 0 107.076 7.075l9.19-9.19a1 1 0 111.414 1.414l-9.19 9.19a7.003 7.003 0 01-9.904-9.904l9.19-9.19a5.002 5.002 0 117.074 7.074l-9.2 9.19a3.001 3.001 0 01-4.244-4.244l8.49-8.48a1 1 0 111.414 1.415l-8.49 8.48a1.002 1.002 0 00.708 1.708c.265 0 .52-.105.708-.293l9.2-9.19a3.003 3.003 0 00-2.123-5.125z","fill":"#04080E"}})])
          )
        }
      }
    